import refreshInterval from './refreshInterval'
import accountSettings from './accountSettings'
import changePassword from './changePassword'
import miniprogSettings from './miniprogSettings'
import glassesSettings from './glassesSettings'
import visitorDeviceSettings from './visitorDeviceSettings'

const zhCN = { 
  userCenter: {
    ...refreshInterval.zhCN,
    ...accountSettings.zhCN,
    ...changePassword.zhCN,
    ...miniprogSettings.zhCN,
    ...glassesSettings.zhCN,
    ...visitorDeviceSettings.zhCN,

    varifyCode: '验证码',
    varifyCodeBtn: '获取验证码',
    varifyCodeBlank: '请输入验证码！',
    varifyCodeSending: '验证码发送中...',
    varifyCodeSendSuccess: '验证码发送成功',
    varifyCodeSendFail: '验证码发送失败'
  } 
}
const enUS = {
  userCenter: {
    ...refreshInterval.enUS,
    ...accountSettings.enUS,
    ...changePassword.enUS,
    ...miniprogSettings.enUS,
    ...glassesSettings.enUS,
    ...visitorDeviceSettings.enUS,

    varifyCode: 'Verification code',
    varifyCodeBtn: 'Get Code',
    varifyCodeBlank: 'Verification code can\'t be blank!',
    varifyCodeSending: 'Verification code sending...',
    varifyCodeSendSuccess: 'Send verification code successfully!',
    varifyCodeSendFail: 'Send verification code failed!'
  }
}
export default { zhCN, enUS }